/**
 * Typewriter Text Constants
 * 
 * Centralized location for all typewriter animation text lines
 * used across login, signup, and other authentication components.
 * 
 * This helps maintain consistency and follows DRY principle.
 */

export const LOGIN_TYPEWRITER_LINES = [
  "Creating time for healthcare professionals",
  "Improving access and adherence", 
  "Reducing administrative burden through AI and Automation"
];

// Additional typewriter text arrays can be added here as needed
// Example:
// export const ONBOARDING_TYPEWRITER_LINES = [
//   "Welcome to the future of healthcare",
//   "Let's get you set up in minutes"
// ];

export default {
  LOGIN_TYPEWRITER_LINES
}; 